<nav class="site-navigation" aria-label="Site-specific navigation">
  <ul class="navigation-level navigation-level-1">
    @for (item of items(); track item.label) {
      <li
        class="navigation-item"
        [class.has-children]="item.children?.length"
        [class.shorebase-navigation-item]="item.label.toLowerCase() === 'shorebase'"
        (mouseenter)="alignFlyout($event)"
        (focusin)="alignFlyout($event)"
      >
        @if (item.target === '_blank') {
          <a
            class="navigation-link navigation-link-level-1"
            href="javascript:void(0);"
            [attr.aria-haspopup]="item.children?.length ? 'true' : null"
            (click)="openNewWindow($event, item.link || null); closeFlyout($event)"
          >
            <span>{{ item.label }}</span>
          </a>
        } @else {
          <a
            class="navigation-link navigation-link-level-1"
            [routerLink]="item.link || null"
            routerLinkActive="is-active"
            [attr.aria-haspopup]="item.children?.length ? 'true' : null"
            (click)="closeFlyout($event)"
          >
            <span>{{ item.label }}</span>
          </a>
        }
        @if (item.children?.length) {
          <ng-container
            *ngTemplateOutlet="submenu; context: { $implicit: item.children, level: 2 }"
          ></ng-container>
        }
      </li>
    }
  </ul>
</nav>

<ng-template #submenu let-entries let-level="level">
  <ul class="navigation-level" [class]="'navigation-level-' + level">
    @for (entry of entries; track entry.label) {
      <li
        class="navigation-item"
        [class.has-children]="entry.children?.length"
      >
        @if (entry.children?.length) {
          <span
            class="navigation-link"
            [class]="'navigation-link-level-' + level"
            [attr.aria-haspopup]="'true'"
          >
            <span>{{ entry.label }}</span>
          </span>
        } @else if (entry.target === '_blank') {
          <a
            class="navigation-link"
            [class]="'navigation-link-level-' + level"
            href="javascript:void(0);"
            [attr.aria-haspopup]="entry.children?.length ? 'true' : null"
            (click)="openNewWindow($event, entry.link || null); closeFlyout($event)"
          >
            <span>{{ entry.label }}</span>
          </a>
        } @else {
          <a
            class="navigation-link"
            [class]="'navigation-link-level-' + level"
            [routerLink]="entry.link || null"
            routerLinkActive="is-active"
            [attr.aria-haspopup]="entry.children?.length ? 'true' : null"
            (click)="closeFlyout($event)"
          >
            <span>{{ entry.label }}</span>
          </a>
        }
        @if (entry.children?.length) {
          <ng-container
            *ngTemplateOutlet="submenu; context: { $implicit: entry.children, level: level + 1 }"
          ></ng-container>
        }
      </li>
    }
  </ul>
</ng-template>